import { Injectable, Injector, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthService } from '../services/user/auth.service';
import { IAppConfig } from '../services/Config/app-config.model';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private injector: Injector, @Inject('appconfig') private config: IAppConfig) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const authService = this.injector.get(AuthService);
		var returnValue: Observable<HttpEvent<any>> = null;
    if (req.url.indexOf(this.config.ApiConfig.ATTACHMENT_API_ENDPOINT) >= 0)
      returnValue = this.CloneRequestForAttachmentApi(req, authService, next);
		if (req.url.indexOf(this.config.ApiConfig.API_ENDPOINT) >= 0)
			returnValue = this.CloneRequestForAPIKey(req, authService, next);
		if (req.url.indexOf(this.config.ApiConfig.PEOPLEANDORG_API_ENDPOINT) >= 0)
			returnValue = this.CloneRequestForKey(req, next, this.config.ApiConfig.PEOPLEANDORG_API_KEY);
		if (req.url.indexOf(this.config.ApiConfig.POSTAL_API_ENDPOINT) >= 0)
			returnValue = this.CloneRequestForKey(req, next, this.config.ApiConfig.POSTAL_API_KEY);
		if(req.url.indexOf(this.config.CoreConfig.USERROLE_API_ENDPOINT) >= 0)
      returnValue = this.CloneRequestForAPIKey(req, authService, next);
    if (req.url.indexOf(this.config.ApiConfig.SMSEnterPriseApi) >= 0)
      returnValue = this.CloneRequestForKeys(req, next, this.config.ApiConfig.SMS_API_KEY, true);
		return returnValue;
	}

	CloneRequestForKey(req: HttpRequest<any>, next: HttpHandler, key: string, useAuthToken?: boolean): Observable<HttpEvent<any>> {
		const authService = this.injector.get(AuthService);
		const authRequest = useAuthToken && authService.getUserProfile() != undefined? req.clone({
			headers: req.headers.set('x-api-key', key).set('authToken', authService.getUserProfile().authToken)
		}) : req.clone({
			headers: req.headers.set('x-api-key', key)
		});
		return next.handle(authRequest);
	}

	private CloneRequestForAPIKey(req: HttpRequest<any>, authService: AuthService, next: HttpHandler): Observable<HttpEvent<any>> {
		const authRequest = req.clone({
			headers: req.headers.set('x-api-key', this.config.ApiConfig.Api_Key)
		});
		return next.handle(authRequest);
  }

  CloneRequestForKeys(req: HttpRequest<any>, next: HttpHandler, key: string, useAuthToken?: boolean): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const authRequest = useAuthToken ? req.clone({
      headers: req.headers.set('x-api-key', key)
        .set('AppToken', this.config.ApiConfig.AppToken)
        .set('DataTokens', this.config.ApiConfig.DataTokens)
    }) : req.clone({
      headers: req.headers.set('x-api-key', key)
    });
    return next.handle(authRequest);
  }

  private CloneRequestForAttachmentApi(req: HttpRequest<any>, authService: AuthService, next: HttpHandler): Observable<HttpEvent<any>> {
    const authRequest = req.clone({
    
    });
    return next.handle(authRequest);
  }
}
